export const OptionsTipoPago = [
  { value: "Unico", label: "Unico" },
  { value: "Diario", label: "Diario" },
  { value: "Semanal", label: "Semanal" },
  { value: "Quincenal", label: "Quincenal" },
  { value: "Mensual", label: "Mensual" },
  { value: "Bimestral", label: "Bimestral" },
  { value: "Trimestral", label: "Trimestral" },
  { value: "Cuatrimestral", label: "Cuatrimestral" },
  { value: "Semestral", label: "Semestral" },
  { value: "Anual", label: "Anual" },
]

export const OptionsTipoComprobante = [
  { label: "Factura", value: "factura" },
  { label: "Boleta", value: "boleta" },
  { label: "RH", value: "RH" },
  { label: "Proforma", value: "proforma" },
  { label: "Nota de credito", value: "nota_credito" },
  { label: "Nota de debito", value: "nota_debito" },
  { label: "Ticket", value: "ticket" },
  { label: "POS", value: "POS" },
  { label: "Recibo", value: "recibo" },
]

export const OptionsMoneda = [
  { label: "Soles", value: "soles" },
  { label: "Dolares", value: "dolares" },
]

export const OptionsEntidadPago = [
  { value: "BCP", label: "BCP" },
  { value: "Scotiabank", label: "Scotiabank" },
  { value: "Interbank", label: "Interbank" },
  { value: "BCP Edu", label: "BCP Edu" },
  { value: "BCP Yess", label: "BCP Yess" },
  { value: "Scotiabank Yess", label: "Scotiabank Yess" },
  { value: "Interbank MC", label: "Interbank MC" },
  { value: "BCP BTL", label: "BCP BTL" },
  { value: "YAPE BTL", label: "YAPE BTL" },
]